import { getRelativeCookTime } from 'oxygen-lib-ui/helpers/date';

export default function printCleanCookTime(minPrep, maxPrep, minCook, maxCook) {
  if (minCook === null || maxCook === null) {
    return '';
  }
  const totalMin = minPrep + minCook;
  const totalMax = maxPrep === null ? minPrep + maxCook : minPrep + maxCook;
  const minTime = getRelativeCookTime(totalMin);
  const maxTime = getRelativeCookTime(totalMax);
  if (minTime === maxTime) {
    return maxTime;
  }
  // else print cook time range
  return `Time: ${minTime} - ${maxTime}`;
}
